module.exports = __webpack_public_path__ + "img/mail.fc43962e.svg";